var Component = require("!../../../node_modules/vue-loader/lib/component-normalizer")(
  /* script */
  null,
  /* template */
  require("!!../../../node_modules/vue-loader/lib/template-compiler/index?{\"id\":\"data-v-9fde1438\"}!../../../node_modules/vue-loader/lib/selector?type=template&index=0!./Privacy.de.vue"),
  /* scopeId */
  null,
  /* cssModules */
  null
)

module.exports = Component.exports



//////////////////
// WEBPACK FOOTER
// ./src/i18n/views/Privacy.de.vue
// module id = 441
// module chunks = 0